// test2881
(2881 && 0);
